import styled from 'styled-components';

const SelectOptionText = styled.div`
	margin: 0;
	padding: 2px 0 0 0;
`;

export default SelectOptionText;